var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"upload-status"},[_vm._v("\n  "+_vm._s(_vm.status)+"\n  "),(_vm.statusMessage)?_c('help-icon',{attrs:{"content":_vm.statusMessage}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }